import React from 'react';
import { Tooltip } from 'antd';
import { useIntl } from 'react-intl';
import { defaultTheme } from '@nxsys/constants/defaultConfig';
import { Icons } from '@nxsys/types/icons';
import { StyledBackButton } from './index.styled';

type AppBackButtonProps = {
  onClick: () => void;
  className?: string;
};

const AppBackButton: React.FC<AppBackButtonProps> = ({
  onClick,
  className,
}) => {
  const { messages } = useIntl();
  const label = messages['common.back'] as string;

  return (
    <Tooltip title={label}>
      <StyledBackButton
        className={className}
        aria-label={label}
        icon={<Icons.IconArrowLeft color={defaultTheme.theme.palette.white} />}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      />
    </Tooltip>
  );
};

export default AppBackButton;
